exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._25smnt4qbkjx1ry9936xnt6nw97gpb4459r497am85zwmbhdkqkjfa274qpg9mruxfzna68gdwqe9brhpzw1psfm1g3gdet893n93cw-AssetsDisplay-module-asset-display{margin-top:20px}", "", {"version":3,"sources":["C:/a/_work/5/s/src/views/NotificationsReview/components/AssetsDisplay/C:/a/_work/5/s/src/views/NotificationsReview/components/AssetsDisplay/AssetsDisplay.module.scss"],"names":[],"mappings":"AAAA,6IACE,eAAgB,CACjB","file":"AssetsDisplay.module.scss","sourcesContent":[".asset-display {\r\n  margin-top: 20px;\r\n}\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"asset-display": "_25smnt4qbkjx1ry9936xnt6nw97gpb4459r497am85zwmbhdkqkjfa274qpg9mruxfzna68gdwqe9brhpzw1psfm1g3gdet893n93cw-AssetsDisplay-module-asset-display"
};